module.exports = __webpack_public_path__ + "img/player202501.4e743026.png";